var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"rotating",attrs:{"src":("/logos/pmat-no-margin" + (_vm.wink ? '-wink' : '') + ".svg"),"alt":"P-MAT"}})}
var staticRenderFns = []

export { render, staticRenderFns }